

import { getElements, ifSelectorExist } from "./utils";

export const ScheduleEngineScripts = () => {
  const links = getElements('a');

  if (ifSelectorExist(links)) {
    links.forEach(link => {
      if (link.getAttribute('onclick') == 'ScheduleEngine.show()') {
        link.addEventListener('click', (e) => {
          e.preventDefault();
        });
      }
    }); 
  }
};
